export const sb = {
    "login": "Prijava",
    "register": "Kreiraj novi nalog",
    "change_password": "Promena lozinke",
    "copyright": "Autorska prava",
    "copyright_value": "Siniat SEE",
    "email_address": "E-mail",
    "address": "Adresa",
    "locality": "Grad",
    "language": "Jezik",
    "state": "Zemlja",
    "password": "Lozinka",
    "forgot_password": "Zaboraviljena lozinka?",
    "enter_account": "Prijava",
    "not_registered": "Kreiraj novi nalog",
    "walls": "Zidovi",
    "linnings": "Obloga",
    "linnings_f": "Obloga sa konektorima",
    "linnings_i": "Samostojeća obloga",
    "linnings_l": "Šaht obloga",
    "linnings_p": "Obloga lepljenjem",
    "linnings_nf": "Akustična obloga sa konektorima",
    "linnings_ni": "Samostojeća akustična obloga",
    "linnings_nuu": "Akustična UU obloga",
    "ceilings": "Plafoni",
    "ceilings_s": "Spušteni plafoni",
    "ceilings_ss": "Samonoseći plafoni",
    "home": "Početna",
    "print": "Štampa",
    "personal_information": "Lični podaci",
    "first_name": "Ime",
    "last_name": "Prezime",
    "last_login": "Poslednja prijava",
    "logins_number": "Broj prijave",
    "phone_number": "Broj telefon",
    "status_active": "Aktivan",
    "is_admin": "Administrator",
    "created_on": "Datum registracije",
    "account_data": "Informacije o nalogu",
    "confirm_password": "Potvrdite lozinku",
    "read_agree": "Prihvatam",
    "terms_conditions": "uslove i odredbe",
    "finish_register": "Registrujte svoj nalog",
    "already_registered": "Da li ste već registrovani? Prijava",
    "required_field": "Ovo je obavezno polje",
    "minimum_characters": "Najmanji broj karaktera je__min__",
    "maximum_characters": "Najveći broj karaktera je __max__",
    "valid_email": "Neispravna e-mail adresa",
    "invalid_phone_format": "Neispavan format",
    "reset_password": "Resetujte lozinku",
    "reset_password_button": "Povratite lozinku",
    "back_to_login": "Nazad na prijavu",
    "page_loading": "Stranica se učitava, molimo sačekajte",
    "new_password": "Nova lozinka",
    "confirm_new_password": "Potvrdite novu lozinku",
    "save_password": "Sačuvaj lozinku",
    "successfully_registered": "Uspešna registracija",
    "successfully_registered_paragraph": "Registracija naloga je uspešna",
    "successfully_registered_approval": "Vaš nalog će biti aktiviran uskoro",
    "resend_confirmation": "Ponovovo pošalji e-mail za potvrdu",
    "account_not_activated": "Vaš nalog nije aktiviran",
    "account_activated": "Vaš nalog je aktiviran",
    "account_activated_description": "Vaš nalog je uspešno aktiviran",
    "resend_confirm_account_description_1": "Popunite e-mail adresu koju ste koristili prilikom registrovanja",
    "resend_confirm_account_description_2": "Nakon što dobijete e-mail, kliknite na \"Potvrdi nalog\" dugme da aktivirate nalog",
    "agree_terms_conditions": "Morate prihvatiti uslove i odredbe kako biste nastavili registraciju",
    "use_new_password": "Lozinka je resetovana. Koristite novu lozinku za prijavu",
    "not_activated": "Niste dobili e-mail o aktivaciji naloga? Možete ovde zatražiti novi ",
    "resend_confirmation_success": "Ako je Vaš nalog registrovan sa ovom e-mail adresom, treba da dobijete link za potvrdu. Molimo Vas proverite spam folder",
    "successfully_requested_reset_password": "Zahtev za promenu lozinke Vam je poslat na e-mail. Molimo Vas da proverite spam folder",
    "saved_password": "Vaša lozinka je sačuvana. Uskoro ćete biti preusmereni",
    "january": "Januar",
    "february": "Februar",
    "march": "Mart",
    "april": "April",
    "may": "Maj ",
    "june": "Jun",
    "july": "Jul",
    "august": "Avgust",
    "september": "Septembar",
    "october": "Oktobar",
    "november": "Novembar",
    "december": "Decembar",
    "logout": "Izađi",
    "list_empty": "Ova lista je prazna",
    "attach_image": "Dodaj sliku",
    "file_too_large": "Dokument je preveliki",
    "file_wrong_file_type_spreadsheet": "Dokument nije podržan. Molimo Vas koristite .xls ili .xlsx dokument",
    "numbers_only": "Samo brojevi",
    "save": "Sačuvaj",
    "back": "Nazad",
    "actions": "Operacije",
    "confirm": "Potvrdi",
    "cancel": "Otkaži",
    "close": "Zatvori",
    "add_offer": "Dodaj ponudu",
    "manage_offers": "Moje ponude",
    "height": "Visina",
    "profile_type": "Vrsta profila",
    "fire_resistance": "Otpornost prema požaru",
    "moisture_resistance": "Vlagootpornost",
    "sound_insulation": "Mineralna vuna",
    "sound_insulation_value": "Zvučna izolacija (dB)",
    "sound_proof": "Zvučna izolacija",
    "back_to_offers": "Nazad na ponude",
    "support": "Vrsta podloge",
    "finishing": "Završna obrada",
    "imported_file": "Dokument je uspešno obrađen",
    "interax": "Osovinsko rastojanje",
    "price": "Cena (EURO)",
    "sap_code": "SAP šifra",
    "product_name": "Naziv proizvoda",
    "amount": "Količina",
    "square_meter": "m²",
    "unit_of_measure": "Jedinica mere",
    "project_info": "Informacije o projektu",
    "joint_length": "Dužina spoja",
    "boq_code": "BoQ naziv",
    "system_name": "Naziv sistema",
    "offer_details": "Detalji ponude",
    "compatible_offers": "Odgovarajuće ponude",
    "choose_system": "Selektujte vrstu sistema",
    "face1Plate1": "Strana 1: Gips-kartonska ploča 1",
    "face1Plate2": "Strana 1: Gips-kartonska ploča 2",
    "face1Plate3": "Strana 1: Gips-kartonska ploča 3",
    "face1Plate4": "Strana 1: Gips-kartonska ploča 4",
    "face2Plate1": "Strana 2: Gips-kartonska ploča 1",
    "face2Plate2": "Strana 1: Gips-kartonska ploča 2",
    "face2Plate3": "Strana 1: Gips-kartonska ploča 3",
    "face2Plate4": "Strana 1: Gips-kartonska ploča 4",
    "more_details": "Više detalja",
    "save_offer": "Sačuvaj ponudu",
    "interax_sustineri": "Osovinsko rastojanje oslonaca",
    "consumuri": "Potrebni materijali",
    "prindere_superioara": "Gornja veza",
    "surface": "Površina",
    "delete_offer_title": "Da li ste sigurni da želite da obrišete ove ponude?",
    "delete_offer_description": "Nakon što ih izbrišete, Vaše ponude neće biti sačuvane",
    "deleted_offer": "Obrisane ponude",
    "delete_session_title": "Da li ste sigurni da želite da obrišete ovaj projekat?",
    "delete_session_description": "Nakon što ga izbrišete, Vaš projekat neće biti sačuvan",
    "company": "Organizacija",
    "company_register": "Naziv firme koju predstavljate",
    "project_code": "Šifra Siniat projekta",
    "job": "Područje delatnosti",
    "contact_person": "Kontakt osoba",
    "email": "E-mail",
    "objective": "Naziv građevinskog projekta",
    "type_objective": "Vrsta građevinskog projekta",
    "type_objective_option_1": "Stambena zgrada",
    "type_objective_option_2": "Poslovna zgrada",
    "type_objective_option_3": "Industrijska zgrada ili skladište",
    "type_objective_option_4": "Šoping centar",
    "type_objective_option_5": "Hotel",
    "type_objective_option_6": "Bolnica",
    "type_objective_option_7": "Zabava(bazen, bioskop, koncertna dvorana,itd.)",
    "type_objective_option_8": "Obrazovanje",
    "location": "Zemlja",
    "description": "Opis",
    "validation_date": "Važi do:",
    "nr": "Ref.br:",
    "delete_session": "Izbrišite projekat",
    "download_session": "Preuzmite projekat",
    "view_session_offers": "Pogledajte ponude za projekat",
    "edit_session": "Izmeni projekat",
    "create_new_session": "Napravi novi projekat",
    "new_offer": "Napravi novu ponudu",
    "edit_offer_plates": "Izmeni gips-kartonske ploče u ponudi",
    "finish_edit_plates": "Završi izmenu gips-kartonskih ploča u ponudi",
    "import_file": "Obrada dokumenta",
    "choose_import": "Izaberite vrstu dokumenta za proračun",
    "imports": "Ubacite dokumenta za proračun",
    "burglary_resistance": "Protivprovalnost",
    "number_of_offers": "Broj kreiranih ponuda",
    "date_created": "Datum kreiranja ponude",
    "back_to_create_offer": "Nazad na generisanje ponuda",
    "generate_offers": "Generišite odgovarajuće ponude",
    "reset_offer": "Poništite polja ponude",
    "my_sessions": "Moji projekti",
    "manage_users": "Upravljanje korisnicima",
    "reports": "Izveštaji",
    "sessions_offers": "Projekti/Ponude",
    "save_session": "Sačuvaj projekat",
    "download": "Preuzmi",
    "download_file": "Preuzmi dokument",
    "download_users": "Lista preuzimanja",
    "next": "Nastavi",
    "walls_s": "Jednostruka obloga",
    "walls_d": "Dvostruka obloga",
    "walls_t": "Trostruka obloga",
    "linnings_s": "Jednostruka obloga",
    "linnings_d": "Dvostruka obloga",
    "linnings_t": "Trostruka obloga",
    "linnings_q": "Četvorostruka obloga",
    "ceilings_plates_s": "Jednostruka obloga",
    "ceilings_plates_d": "Dvostruka obloga",
    "ceilings_plates_t": "Trostruka obloga",
    "ceilings_plates_q": "Četvorostruka obloga",
    "date_validation": "Datum provere",
    "face": "Strana",
    "exterior": "Spoljašnji",
    "and": "I",
    "sistem_weight": "Težina sistema",
    "montant_type": "Vrsta profila",
    "upper_guiding": "Vrsta gornje vođice",
    "lower_guiding": "Vrsta donje vođice",
    "plating_types": "Vrsta gips-kartonske ploče",
    "plating_type_face_a": "Vrsta gips-kartonske ploče, strana A",
    "plating_type_face_b": "Vrsta gips-kartonske ploče, strana B",
    "upper_support": "Vrsta podloge, gore",
    "wool_type": "Izolacija",
    "thickness_system": "Debljina sistema",
    "ceilings_distance": "Visina spuštanja",
    "ceilings_support": "Vrsta potpore",
    "system_code": "Šifra sistema",
    "protection_direction": "Smer zaštite",
    "sound_insulation_label": "Zvučna izolacija",
    "plating_type_lower_face": "Gips-kartonska ploča, donja strana",
    "plating_type_upper_face": "Gips-kartonska ploča, gornja strana",
    "main_structure": "Vrsta glavne potkonstrukcije",
    "secondary_structure": "Sekundarna potkonstrukcija",
    "parameter_structure": "Vrsta profila",
    "interax_secondary": "Razmak sekundarne potkonstrukcije",
    "type_intermediate_plate": "Vrsta srednje gipsane ploče",
    "distance": "Rastojanje između konstrukcije",
    "structure_type": "Vrsta potpore",
    "manage_account": "Moj nalog",
    "edit_account": "Izmeni podatke o nalogu",
    "finish_edit_account": "Sačuvaj podatke o nalogu",
    "edit_password": "Izmeni lozinku",
    "edit_password_confirm": "Izmeni korisničku lozinku",
    "edit_password_cancel": "Poništi izmenu lozinke",
    "based_plates": "Osnovni sistem ploča",
    "walls_s_asimetric": "Zidovi S - asimetrični",
    "walls_s_intermediar_d": "Dvostruka obloga",
    "walls_s_intermediar_t": "Trostruka obloga",
    "intermediate_plate": "Srednja gipskartonska ploča",
    "too_much": "Ova vrednost je previsoka",
    "max_opening": "Max. otvor",
    "price_per_unit": "Cena (EUR)/m²",
    "rows_per_page": "Redovi po strani:",
    "no_range": "Van opsega!",
    "no_offers": "Trenutno nema kreirane ponude",
    "passwords_must_match": "Lozinka se ne podudara! Molimo Vas unesite ponovo",
    "description_popup": "Prikazano je 6 najjeftinijih sistema koji odgovaraju Vašim zahtevima. U kolonama se nalaze mnoge funkcije svakog sistema, tako da možete selektovati Vama odgovarajuću. Kliknite OK da nastavite",
    "search": "Pretraga",
    "less_table_cols": "Sažmi tabelu",
    "report": "Izveštaj",
    "import": "Uvezi",
    "materials": "Potrošnja",
    "allowed_plates": "Dozvoljene ploče",
    "products": "Proizvodi",
    "ceilings_plates_s_tooltip": "Jednostruka obloga",
    "ceilings_plates_d_tooltip": "Dvostruka obloga",
    "ceilings_plates_t_tooltip": "Trostruka obloga",
    "ceilings_plates_q_tooltip": "Četvorostruka obloga",
    "separative": "Razdvojni tip",
    "linnings_noisy_double": "Dvostruka akustična obloga",
    "linnings_noisy_triple": "Trostruka akustična obloga",
    "price_list": "Cenovnik",
    "attach_file": "Otpremite dokument",
    "attach_file_for": "Otpremite dokument za uvoz",
    "attach_file_by": "Dokument priložio",
    "attach_file_last_timestamp": "Poslednja izmena za __dokument__ je bila",
    "attach_file_last_file": "Poslednji priložen dokument",
    "thickness": "Debljina",
    "choose_project": "Izaberite projekat za ovu ponudu",
    "create_new_project": "Kreiraj novi projekat",
    "quit": "Izađi",
    "unspecified": "Neodređeno",
    "product": "Proizvod",
    "select_project": "Selektuj projekat",
    "systemType": "Tip sistema",
    "PDF_details": "PDF detalji",
    "DWG_details": "DWG detalji",
    "brochures_sistems": "Brošure za sisteme",
    "assembly_conformity_declarations": "Deklaracije o usaglašenosti skupštine",
    "approval_procedure": "Procedura odobrenja",
    "systemCode": "Šifra sistema",
    "technical_characteristics": "Tehničke karakteristike",
    "value": "Vrednost",
    "more_details_here": "Više detalja ovde",
    "create_offer": "Napravi ponudu",
    "walls_d_simple": "Zidovi D - jednostruko oblaganje",
    "walls_d_double": "Zidovi D - dvostruko oblaganje",
    "walls_d_triple": "Zidovi D - trostruko oblaganje",
    "walls_s_double": "Zidovi S - dvostruko oblaganje",
    "walls_s_triple": "Zidovi S - trostruko oblaganje",
    "walls_s_double_intermediate": "Zidovi S - dvostruki sa srednjom pločom",
    "walls_s_triple_intermediate": "Zidovi S - trostruki sa srednjom pločom",
    "walls_sl_simple": "Zidovi SL - jednostruko oblaganje",
    "walls_sl_double": "Zidovi SL- dvostruko oblaganje",
    "walls_sl_triple": "Zidovi SL- trostruko oblaganje",
    "walls_sla_triple": "Zidovi SLA - trostruko oblaganje",
    "plating_fix_simple": "Obloge sa konektroima - jednostruka obloga",
    "plating_fix_double": "Obloge sa konektroima - dvostruka obloga",
    "plating_fix_triple": "Obloge sa konektroima - trostruka obloga",
    "plating_fix_quadruple": "Obloge sa konektroima - četvorostruka obloga",
    "plating_indep_simple": "Samostojeće obloge - jednostruka obloga",
    "plating_indep_double": "Samostojeće obloge - dvostruka obloga",
    "plating_indep_triple": "Samostojeće obloge - trostruka obloga",
    "plating_indep_quadruple": "Samostojeće obloge - četvorostruka obloga",
    "plating_liniar_double": "Šaht obloge - dvostruka obloga",
    "plating_liniar_triple": "Šaht obloge - trostruka obloga",
    "plating_liniar_quadruple": "Šaht obloge - četvorostruka obloga",
    "plating_sticking": "Obloga lepljenjem",
    "noisy_plating_fix_triple": "Akustična obloga s konektorima - trostruka obloga",
    "noisy_plating_indep_double": "Samostojeća akustična obloga - dvostruka obloga",
    "noisy_plating_indep_triple": "Samostojeća akustična obloga - trostruka obloga",
    "noisy_plating_uu_double": "Akustična UU obloga - dvostruka obloga",
    "noisy_plating_uu_triple": "Akustična UU obloga - trostruka obloga",
    "ceiling_suspended_simple": "Spušteni plafoni - jednostruka obloga",
    "ceiling_suspended_double": "Spušteni plafoni - dvostruka obloga",
    "ceiling_suspended_triple": "Spušteni plafoni - trostruka obloga",
    "ceiling_suspended_quadruple": "Spušteni plafoni - četvorostruka obloga",
    "ceiling_autoport_simple": "Samonoseći plafoni - jednostruka obloga",
    "ceiling_autoport_double": "Samonoseći plafoni - dvostruka obloga",
    "ceiling_autoport_triple": "Samonoseći plafoni - trostruka obloga",
    "ceiling_autoport_quadruple": "Samonoseći plafoni - četvorostruka obloga",
    'create_offer_walls_d_simple': "Napravi ponudu - D-zidovi - Jednostavna obloga",
    'create_offer_walls_d_double': "Napravi ponudu - D-zidovi - Dvostruko obloženi",
    'create_offer_walls_d_triple': "Napravi ponudu - D-zidovi - Trostruka obloga",
    'create_offer_walls_s_double': "Napravi ponudu - S-zidovi - dvostruko obloženi",
    'create_offer_walls_s_triple': "Napravi ponudu - S-zidovi - trostruka obloga",
    'create_offer_walls_s_asimetric': "Napravi ponudu - S-zidovi - asimetrični",
    'create_offer_walls_s_double_intermediate': "Napravi ponudu - S zidovi - Dupli srednji nivo",
    'create_offer_walls_s_triple_intermediate': "Napravi ponudu - S zidovi - Trostruki srednji nivo",
    'create_offer_walls_sl_simple': "Napravi ponudu - SL zidovi - jednostavno obloženi",
    'create_offer_walls_sl_double': "Napravi ponudu - SL zidovi - dvostruko obloženi",
    'create_offer_walls_sl_triple': "Napravi ponudu - SL zidovi - trostruka obloga",
    'create_offer_walls_sla_triple': "Napravi ponudu - SLA zidovi - Trostruka obloga",
    'create_offer_plating_fix_simple': "Napravi ponudu - Obloga sa pričvršćivačima - Jednostavno",
    'create_offer_plating_fix_double': "Napravi ponudu - Obloga sa pričvršćivačima - Duplo",
    'create_offer_plating_fix_triple': "Napravi ponudu - Obloga sa pričvršćivačima - Trostruka",
    'create_offer_plating_fix_quadruple': "Napravi ponudu - Obloga sa pričvršćivačima - Četvorostruka",
    'create_offer_plating_fix_ei': "Napravi ponudu - Obloga sa pričvršćivačima - EI180 min (5 panela)",
    'create_offer_plating_indep_simple': "Napravi ponudu - Nezavisna obloga - Jednostavno",
    'create_offer_plating_indep_double': "Napravi ponudu - Nezavisna obloga - Dvostruka",
    'create_offer_plating_indep_triple': "Napravi ponudu - Nezavisna obloga - Trostruka",
    'create_offer_plating_indep_quadruple': "Napravi ponudu - Nezavisna obloga - Četvorostruka",
    'create_offer_plating_indep_ei': "Napravi ponudu - Nezavisna obloga - EI180 min (5 panela)",
    'create_offer_plating_liniar_double': "Napravi ponudu - Linearna obloga - Dvostruka",
    'create_offer_plating_liniar_triple': "Napravi ponudu - Linearna obloga - Trostruka",
    'create_offer_plating_liniar_quadruple': "Napravi ponudu - Linearna obloga - Četvorostruka",
    'create_offer_plating_liniar_cv': "Napravi ponudu - Linearna obloga - EI180 min (5 panela)",
    'create_offer_plating_sticking': "Napravi ponudu - Lepljenje furnira",
    'create_offer_noisy_plating_fix_triple': "Napravi ponudu - Bučna obloga sa pričvršćivačima - Trostruka",
    'create_offer_noisy_plating_indep_double': "Napravi ponudu - Nezavisna bučna obloga - Dupla",
    'create_offer_noisy_plating_indep_triple': "Napravi ponudu - Nezavisna bučna obloga - Trostruka",
    'create_offer_noisy_plating_uu_double': "Napravi ponudu - Bučna UU obloga - Dupla",
    'create_offer_noisy_plating_uu_triple': "Napravi ponudu - Bučna UU obloga - Trostruka",
    'create_offer_ceiling_suspended_simple': "Napravi ponudu - Spušteni plafoni - Jednostavno",
    'create_offer_ceiling_suspended_double': "Napravi ponudu - Spušteni plafoni - Dupli",
    'create_offer_ceiling_suspended_triple': "Napravi ponudu - Spušteni plafoni - Trostruki",
    'create_offer_ceiling_suspended_quadruple': "Napravi ponudu - Spušteni plafoni - Četvorokrevetni",
    'create_offer_ceiling_autoport_simple': "Napravi ponudu - Samonoseći plafoni - Jednostavno",
    'create_offer_ceiling_autoport_double': "Napravi ponudu - Samonoseći plafoni - Dupli",
    'create_offer_ceiling_autoport_triple': "Napravi ponudu - Samonoseći plafoni - Trostruki",
    'create_offer_ceiling_autoport_quadruple': "Napravi ponudu - Samonoseći plafoni - Četvorostruki",
    'create_offer_walls_smart_simple' : "Napravi ponudu - Pametni zidovi - Jednostavan plakat",
    'create_offer_walls_smart_double' : "Napravi ponudu - Pametni zidovi - Dvostruko obloženi",
    "download_offer": "Preuzmite ponudu",
    "delete_offer": "Izbriši ponudu",
    "compatible_offers:": "Odgovarajuća ponuda",
    "country": "Zemlja",
    "direction_0": "Nespecificirano",
    "direction_1": "Zaštita odozdo na gore",
    "direction_2": "Zaštita odozgo na dole",
    "direction_3": "Obostrana zaštita",
    "dont_show_message": "Ne prikazuj ovu poruku više",
    "principal_structure": "Glavna konstrukcija",
    "beam_type": "Vrsta grede",
    "change_county": "Promenite okrug",
    "save_county": "Sačuvaj okrug",
    "county": "Okrug",
    "access": "Pristup",
    "any": "Bilo koji",
    "one_face": "Jedna strana",
    "one_exterior_face": "Spoljna strana",
    "two_faces": "Dve strane",
    "with_mineral_wool": "Sa mineralnom vunom",
    "without_mineral_wool": "Bez mineralne vune",
    "without_finishing": "Bez završne obrade",
    "with_finishing": "Sa završnom obradom",
    "Planseu beton armat": "Armirani beton",
    "Tabla cutata de acoperis": "Trapezasti lim",
    "Planseu colaborant": "Kolaborativni beton",
    "nespecificat": "neodređeno",
    "minute": "Minuti",
    "simple_structure": "Jednostruka konstrukcija",
    "double_structure": "Dvostruka konstrukcija",
    "one_face_cementex": "Jedna strana Cementex",
    "without": "Bez",
    "vinclu": "Ugao",
    "continue": "Nastavi",
    "Da": "Da",
    "Nu": "Ne",
    "RON": "EURO",
    "Fara": "Bez",
    "interaxSustineri": "Međukonektori",
    "support_type_brida ": "Prirubnica",
    "support_type_tirant ": "Navojna šipka",
    "support_type_nonius ": "Nonius",
    "support_type_tija_m8": "M8 navoj",
    "support_type_racord_lemn ": "Konektor za drvo",
    "support_type_brida_ac ": "Akustična prirubnica",
    "not_a_number ": "Uneta vrednost mora biti broj",
    "min": "min",
    "max ": "max",
    "support_type_beton": "Beton",
    "support_type_zidarie": "Opeka",
    "support_type_tencuieli": "Gips",
    "support_type_altele": "Drugo",
    "bride": "Veze",
    "cu_rezistente": "Sa otporom",
    "create_offer_walls_smart_simple": "Zidovi Smart - jednostruka obloga",
    "create_offer_walls_smart_double": "Zidovi Smart - dvostruka obloga",
    "create_offer_plating_smart_sticking": "Obloga lepljenjem",
    "create_offer_plating_smart_fix_simple": "SMART Obloge sa konektorima - jednostruka obloga",
    "create_offer_plating_smart_fix_double": "SMART Obloge sa konektorima - dvostruka obloga",
    "create_offer_plating_smart_indep_simple": "Samostojeće obloge SMART - jednostruka obloga",
    "create_offer_plating_smart_indep_double": "Samostojeće obloge SMART - dvostruka obloga",
    "create_offer_ceiling_smart_suspended_simple": "Spušteni plafoni SMART - Jednostruka obloga",
    "create_offer_ceiling_smart_suspended_double": "Spušteni plafoni SMART - dvostruka obloga",
    "supoort_type_autoportant": "Samonoseći plafoni",
    "unit_mm": "mm",
    "unit_cm": "cm",
    "unit_m": "m",
    "unit_mp": "m2",
    "unit_kg": "kg",
    "unit_kg_per_mp": "kg/m2",
    "unit_kg_per_mc": "kg/m3",
    "unit_pcs": "kom",
    "unit_db": "dB",
    "unit_min": "min",
    "unit_max": "max",
    "select": "Izaberite",
    "download_selection": "Preuzmite izbor",
    "404": "Žao nam je, ali stranica nije dostupna",
    "plating_fix_ei": "Obloge s konektorima - EI180 min (5 gipskartonskih ploča)",
    "plating_indep_ei": "Samostojeće obloge - EI180 min (5 gipskartonskih ploča)",
    "plating_liniar_cv": "Šahte - EI180 min (5 gipskartonskih ploča)",
    "collaborative_concrete": "Noseća ploča",
    "unspecified": "Neodređeno",
    "walls_smart": "Smart Zidovi",
    "linings_smart": "Smart Obloge",
    "ceilings_smart": "Smart Plafoni",
}